module.exports = __webpack_public_path__ + "static/img/page20.c55b671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page20.jpg
// module id = q9L4
// module chunks = 0